export default {
    install(Vue, options) {
        if (process.env.VUE_APP_PROJECT_ACS == 'true') {
            Vue.prototype.isACS = true;
        } else {
            Vue.prototype.isACS = false;
        }

        Vue.prototype.universalSearchUrl = process.env.VUE_APP_UNIVERSALSEARCH_URL;


        // observable properties are reactive
        var observable = Vue.observable({
            isWide: null,
            isDark: null,
        });

        var resizeObserver = new ResizeObserver(() => {
            observable.isWide = window.matchMedia('(min-width: 768px)').matches;
        });
        resizeObserver.observe(window.document.body);

        // expose observable properties using property getters
        Object.defineProperty(Vue.prototype, 'isWide', {
            get() {
                return observable.isWide;
            },
        });
    },
}